export const VALIDATE_EMAIL_REGEX =
  /^[\+_a-z0-9-'&=]+(\.[\+_a-z0-9-']+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;

export const VALIDATE_POSTCODE_REGEX =
  /^[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? ?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}$/i;

export const VALIDATE_SORT_CODE_REGEX = /^\b\d{2}([-\s]?)\d{2}\1\d{2}$/i;

export const VALIDATE_COMPANY_NUMBER_REGEX = /^(?:[A-Z]{1,2}|[0-9]{2})[0-9]{6}$/;

export const CHARITY_NUMBER_REGEX = /^(?:SC[0-9]{6}|[0-9]{6,8})$/;
